<template>
  <q-layout view="lHh Lpr lFf">
    <MainNav />
    
    <q-page-container>
      <q-page class="app-page">
        <router-view/>
      </q-page>
    </q-page-container>
    
    <Footer />
  </q-layout>
</template>

<script>
import MainNav from './components/MainNav.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    MainNav,
    Footer
  }
};
</script>

<style>
.app-page {
  min-height: 100%;
  padding: 0;
  overflow-x: clip;
}
</style>
